<template>
  <div :class="border?'breadBox':'breadBox noBorder'">
    <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right" v-if="pagetypes != '视频资源' &&　pagetypes != '课例展评'">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="item in levelList" :key="item.path" :to="{ path: item.path }">
          <span>{{ item.meta.title }}</span>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
    <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right" v-else>
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="item in backlist" :key="item.path">
          <span style="cursor: pointer;" @click="backpage(item.path)">{{ item.title }}</span>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>

</template>

<script>
  export default {
    props: {
      border: {
        type: Boolean,
        default: true
      },
      pagetypes: {
        type: String,
        default: ''
      },
      index: {
        type: String,
        default: ''
      },
      groupId: {
        type: String,
        default: ''
      },
      isItinternal: {
        type: String,
        default: ''
      },
      videoTitle: {
        type: String,
        default: ''
      },
      group: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        levelList: null,
        backlist: []
      };
    },
    watch: {
      $route() {
        this.getBreadcrumb();
      }
    },
    created() {
      if (this.group == 0) {
        this.backlist = [
          {
            title: '返回',
            path: '/teacherMember?id=' + this.groupId + '&index=' + this.index
          },
          {
            title: this.videoTitle,
            path: ''
          }
        ]
      } else if (this.group == 2) {
        this.backlist = [
          {
            title: '返回',
            path: '/principalMember?id=' + this.groupId + '&index=' + this.index
          },
          {
            title: this.videoTitle,
            path: ''
          }
        ]
      } else if (this.group == 4) {
        this.backlist = [
          {
            title: '返回',
            path:''
          },
          {
            title: this.videoTitle,
            path: ''
          }
        ]
      } else {
        this.backlist = [
          {
            title: '返回',
            path: '/studyGroupDetailList?id=' + this.groupId + '&index=' + this.index
          },
          {
            title: this.videoTitle,
            path: ''
          }
        ]
      }
      this.getBreadcrumb();
    },
    methods: {
      getBreadcrumb() {
        let matched = this.$route.matched.filter(
          item => item.meta && item.meta.title
        );
        // var dataPrev = localStorage.getItem('router');
        // if()
        // localStorage.setItem("router", JSON.stringify(matched));
        // console.log(localStorage.getItem('router'));
        const first = matched[0];
        if (!this.isIndex(first)) {
          matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
          console.log(matched);
          this.levelList = matched;
        } else {
          this.levelList = [{ path: "/", meta: { title: "首页" } }];
        }
      },
      backpage(path){
        if(this.group != 4){
          this.$router.push({
            path: path
          });
        }else{
          this.$router.go(-1)
        }
      },
      isIndex(route) {
        const redirect = route && route.redirect;
        if (!redirect) {
          return false;
        }
        return redirect === "/home";
      }
    }
  };
</script>

<style>
  .breadBox {
    padding: .26rem 0px .16rem 0px;
    border-bottom: .01rem solid #e6e6e6;
  }

  .breadBox.noBorder {
    border-bottom: none;
  }

  .el-breadcrumb__separator {
    margin: 0;
    padding: 0px .1rem;
  }

  .app-breadcrumb.el-breadcrumb {
    padding-top: .04rem;
  }

  /* breadcrumb transition */
  .breadcrumb-enter-active,
  .breadcrumb-leave-active {
    transition: all 0.5s;
  }

  .is-link {
    color: rgba(0, 0, 0, 0.4);
    font-weight: 500 !important;
  }

  .el-breadcrumb__item:last-child .is-link {
    color: rgba(0, 0, 0, 0.9) !important;
  }

  .breadcrumb-enter,
  .breadcrumb-leave-active {
    opacity: 0;
    transform: translateX(.2rem);
  }

  .breadcrumb-move {
    transition: all 0.5s;
  }

  .breadcrumb-leave-active {
    position: absolute;
  }

  .app-breadcrumb.el-breadcrumb {
    margin-left: .08rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/Bread.vue